import type {
  CmsApiSplitBlockAppearance,
  CmsApiSplitBlockText,
} from '#/modules/cms/api/types/blocks/CmsApiSplitContentBlock';
import { CmsApiLinkType } from '#/modules/cms/api/types/CmsApiLink';

import { CmsSplitContentTextContent_Box_1 } from './CmsSplitContentTextContent.styled';
import { CmsSplitContentTextContentInner } from './CmsSplitContentTextContentInner';

type Props = {
  section: CmsApiSplitBlockText;
  appearance: CmsApiSplitBlockAppearance;
  index: number;
  blockId: string;
  imageTextBlock: boolean;
  blockIndex: number;
  pageUpdated: string;
  showBackgroundImage: boolean;
};

export function CmsSplitContentTextContent({
  appearance,
  blockId,
  blockIndex,
  imageTextBlock,
  index,
  pageUpdated,
  showBackgroundImage,
  section,
}: Props) {
  const showTextBox = ['FULL_WIDTH', 'OVERLAPPING'].includes(appearance);

  const hideButton =
    section.data.button?.type === CmsApiLinkType.CMS_PAGE &&
    !section.data.button.data.pageTitle;

  return (
    <CmsSplitContentTextContent_Box_1
      data-qa-id={`split-content-section-${index}`}
      data-not-image-text-block={!imageTextBlock ? true : undefined}
      data-image-text-block={imageTextBlock ? true : undefined}
      key={blockId}
      style={{ zIndex: showTextBox ? 1 : undefined }}
    >
      <CmsSplitContentTextContentInner
        appearance={appearance}
        blockId={blockId}
        blockIndex={blockIndex}
        index={index}
        pageUpdated={pageUpdated}
        label={section.data.label}
        headline={section.data.headline}
        html={section.data.html}
        button={section.data.button}
        showTextBox={showTextBox}
        hideButton={Boolean(hideButton)}
        showBackgroundImage={showBackgroundImage}
      />
    </CmsSplitContentTextContent_Box_1>
  );
}
